module.exports = __webpack_public_path__ + "static/media/mia-malkova-lose.f25c5ebd.jpg";